import { useChatbotsLimits } from "@zapier/client";
import { Text } from "@zapier/design-system";
import { useTranslations } from "@zapier/i18n";
import { MONOLITH_BASE_URL, getChatbotsIndexUrl } from "@zapier/utils";
import styles from "./ChatbotsPlanInfo.module.css";

const capitalize = (text: string) =>
  text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

const getUpgradeUrl = (planType: string) => {
  const targetTier = planType === "free" ? "premium" : "advanced";
  const redirectUrl = encodeURIComponent(
    `${MONOLITH_BASE_URL}${getChatbotsIndexUrl()}`,
  );
  return `${MONOLITH_BASE_URL}/app/planbuilder/add-ons?chatbots=chatbots-${targetTier}&redirectUrl=${redirectUrl}`;
};

export function ChatbotsPlanInfo() {
  const t = useTranslations("chatbots-header");
  const { chatbotCount, chatbotLimit, planName, isLoading } =
    useChatbotsLimits();

  if (isLoading || chatbotCount === undefined || chatbotLimit === undefined) {
    return;
  }

  const currentPlanName = planName ?? "free";
  const formattedPlanName =
    currentPlanName === "premium"
      ? t("plan-info.plan-name-premium")
      : capitalize(currentPlanName);
  const planInfo = t("plan-info.label", {
    planName: formattedPlanName,
    chatbotCount,
    chatbotLimit,
  });
  const upgradeUrl = getUpgradeUrl(currentPlanName);
  const isAdvanced = currentPlanName === "advanced";

  return (
    <div className={styles.root}>
      <Text type="MinimalPrint1Multiline" color="TextWeakest">
        {planInfo}
      </Text>
      <span className={styles.separator}>•</span>
      <a href={upgradeUrl} className={styles.upgradeLink}>
        {isAdvanced ? t("plan-info.manage") : t("plan-info.upgrade")}
      </a>
    </div>
  );
}
